import styled from 'styled-components';

export const DivRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  justify-content: space-between;

`



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/counter/styled.js